<!--  -->
<template>
<div id="antiques" class='layout'>
    <div class="list">
        <Card @handleItem="handleItem(item)" v-for="(item, i) in list" :item="item" :key="i" />
    </div>
    <div class="paging" :class="{ pagingshow: total }" v-if="!isMobile">
          <Paging
            @clickHandle="pageChange"
            :current="currentPage"
            :total="total"
            :equable="pageSize"
          />
        </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Card from "@/components/card";
import Paging from "@/components/paging";
export default {
name: 'ui-antiques',
//import引入的组件需要注入到对象中才能使用
components: {
    Card,
    Paging
},
data() {
//这里存放数据
return {
      layoutshow:true,
      list:[],
      classsifyData:[],//分类后的数据总和
      ALL:[],//初始获取的所有数据列表
      total: 0,
      pageSize: 8,
      currentPage: 1,
      show:false,
      detail:false//是否弹出详情页
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    currentPage(){
      this.getList()
    }
},
//方法集合
methods: {
   onClose() {
         setTimeout(() => {
        document.body.removeChild(this.$el);
        this.$destroy();
      }, this.duration);
    },
    pageChange(num) {
      console.log(num)
      this.currentPage = num
    },
    handleItem(item){
        
        /* this.detail = true; */
        this.$showDetail(item)

    },
async getList() {
      let res = await this.$http({
        method: "get",
       url: `data.json`
      });
      this.ALL = res.list;
      this.show = true;
     /*  this.$store.commit('getList',res.list); */
      this.list = res.list.slice((this.currentPage-1)*8,this.currentPage*8);      
      this.total = res.list.length;
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.getList();
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
this.getList()
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .layout {
        position:absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        width:78.6vw;
        height:75.7vh;
        background:rgba(0,0,0,0.3);
        border-radius:2vw;
        border:1px solid #a61f24;
        .list {
            display:flex;
            flex-wrap:wrap;
            justify-content:center;
            margin-top:3vw;

        }
        .paging {
      // border-left: #e5e5e5 1px solid;
      margin-bottom: 40px;
      transition: all 0.4s ease;
      & /deep/ .p-layout {
        text-align: center;
        margin-top: 10px;
      }
      & /deep/ .p-layout a:not(:last-child) {
        margin: 10px 14px;
        display: inline-block;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
        position: relative;
        transition: color 0.3s;
        color: @theme;
        font-size: 16px;
      }
      & /deep/ .p-layout a:last-child {
        position: relative;
        top: 7px;
        display: -ms-inline-flexbox;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        height: 27px;
        padding: 0 9px;
      }
      & /deep/ .p-layout a:last-child::before,
      & /deep/ .p-layout a:last-child::after {
        content: "";
        display: inline-block;
        will-change: transform;
        transition: transform 0.3s;
      }

      & /deep/ .p-layout a:not(:last-child).active::after,
      & /deep/ .p-layout a:not(:last-child).active,
      & /deep/ .p-layout a:not(:last-child):hover,
      & /deep/ .p-layout a:not(:last-child):hover::after {
        color: @sub-theme;
        transform: scaleX(1);
        text-align: center;
      }

      & /deep/ .p-layout a:not(:last-child).active {
        position: relative;
        width: 28px;
        height:27px;
        line-height:27px;
        background:#a61f24;
        font-size: 14px;
        color:#f9f5e7;
      }
    }
        
    }
</style>